import { observable } from "mobx";
import CabotagemService from "../../../../services/CabotagemService";
import moment from "moment";

export default class CabotagemCadastrarStore {

    @observable novaCabotagem;
    @observable navioSelecionado;
    @observable salvando;
    @observable msgEmail;

    constructor(editando) {
        if (editando) {
            this.novaCabotagem = editando;
        } else {
            this.navioSelecionado = false;
            this.regimeSelecionado = false
            this.novaCabotagem = {
                WebCteId: 0,
                Cte: "",
                Cntr: "",
                Chave: "",
                Regime: "",
                Operacao: "",
                Navio: "",
                Email: "",
                Username: "",
                Booking: "",
                ClibrsId: 0,
                Cliente: "",
                Status: "",
                StatusDsc: "",
                DtEntrada: "",
                DtCadastro: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
                DtInativou: null,
                Observacao: "",
                UsuarioCadastro: "",
                UsuarioInativou: ""
            };
        }

        this.salvando = false;

        this.msgEmail = false;

        this.service = new CabotagemService();
    };

    setNavio = (event) => {
        if (event)
            this.navioSelecionado = event;
        else
            this.navioSelecionado = false;
    };



    escolherRegime = (event) => {
        this.novaCabotagem.Regime = event.value
        this.regimeSelecionado = event
    }

}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/stores/CabotagemCadastrarStore.js